export const axisFormatter = (value: number) => {
  if (value >= 1_000_000_000) {
    return `$${(value / 1_000_000_000).toLocaleString()}B`;
  }
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toLocaleString()}M`;
  }
  return `$${(value / 1_000).toLocaleString()}k`;
};
